import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL, offer } from '../data/offer';
type CtaButtonProps = {
  label: string;
  id?: string;
  showMicrocopy?: boolean;
  tone?: 'light' | 'dark';
  className?: string;
};
export function CtaButton({
  label,
  id,
  showMicrocopy = true,
  tone = 'light',
  className = ''
}: CtaButtonProps) {
  return <div className={`mx-auto w-full max-w-xl ${className}`} data-id="element-82" data-mp="cmvlvlmdc3uj">
      <a id={id} href={CHECKOUT_URL} className="animate-cta-ring group flex w-full items-center justify-center gap-3 rounded-2xl bg-cta-600 px-5 py-[18px] text-center font-display text-[21px] font-extrabold uppercase leading-[1.1] tracking-wide text-white shadow-[0_6px_0_0_#14532D] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-cta-700 active:translate-y-[4px] active:shadow-[0_2px_0_0_#14532D] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold-400 sm:text-2xl" data-id="element-83" data-mp="qjiljw5ph845">
        <span data-id="element-84" data-mp="157n32wt0vdlc">{label}</span>
        <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" strokeWidth={3} aria-hidden="true" data-id="element-85" data-mp="35xnzwvgqa4jw" />
      </a>
      {showMicrocopy && <p className={`mt-4 text-center text-[13px] leading-snug ${tone === 'dark' ? 'text-slate-300' : 'text-muted'}`} data-id="element-86" data-mp="3ex2rxzcjmn6i">
          {offer.microcopy}
        </p>}
    </div>;
}